class BatchAnim {
    constructor() {
        const items = document.querySelectorAll('[data-batch]');
        $(window).on('transitionDone', function () {
            ScrollTrigger.batch(items, {
                start: 'top 90%',
                onEnter: (elements, triggers) => {
                    gsap.to(elements, {
                        opacity: 1,
                        y: 0,
                        stagger: 0.15,
                    });
                }
            });
        });
    }
}
